import { Button, Col, Row } from "react-bootstrap";
import { useChangePasswordContext } from "../contexts/ChangePasswordContext";
import { useLoginContext } from "../contexts/LoginContext";
import { useRegisterContext } from "../contexts/RegisterContext";
import { ErrorMsg } from "./Error";
import { Msg } from "./Msg";

const Header = () => {
	const { loggedIn, clienteInfo, cuil } = useLoginContext();
	const { registrandose } = useRegisterContext();
	const { cambiandoPass, setCambiandoPass } = useChangePasswordContext();

	const handleLogout = () => {
		window.location.reload();
	};

	return (
		<Row>
			<Col>
				<ErrorMsg />
				<Msg />
				{!loggedIn ? (
					!registrandose ? (
						<h3 className='title'>:: Acceso a Clientes ::</h3>
					) : (
						<h3 className='title'>:: Alta de Usuario ::</h3>
					)
				) : (
					<>
						<h3 className='title'>{!cambiandoPass ? "Documentación Técnica" : "Cambio de Contraseña"}</h3>
						<h4 className='title' style={{ marginTop: "10px", marginBottom: "10px" }}>
							{!cambiandoPass ? `Bienvenido, ` : `Para la cuenta de: `}
							{clienteInfo.razon.toUpperCase()}
						</h4>
						<small>CUIL : {cuil}</small>
						{!cambiandoPass && (
							<Button
								variant='link'
								size='sm'
								onClick={() => setCambiandoPass(true)}
								style={{ marginTop: "0" }}
							>
								Cambiar contraseña
							</Button>
						)}
						<Button variant='link' size='sm' onClick={handleLogout} style={{ marginTop: "0" }}>
							Cerrar Sesión
						</Button>
					</>
				)}
			</Col>
		</Row>
	);
};

export default Header;
